import { Image, Text } from '@react-pdf/renderer';
import { leaveApplicationPDFStyles } from './styles';

type SignatureProps = {
  value?: string;
};

export const Signature = ({ value }: SignatureProps) => {
  if (!value) {
    return <Text>.........................................</Text>;
  }

  if (value.startsWith('data:')) {
    return <Image style={leaveApplicationPDFStyles.signatureImage} src={value} />;
  }

  return <Text>{value}</Text>;
};
